import React from "react";
import "./LoadingSpinner.scss";

export default function LoadingSpinner({ hasRows, text }) {
  return (
    <div className={`spinner-container ${!!text && hasRows ? 'hasText ' : ''}`}>
      {!!text && hasRows ? <div className="spinner-text">{text}</div> : null}
      <div className="loading-spinner"></div>
    </div>
  );
}